<template>
    <md-field>
        <label for="selectedIndicator">Indicators</label>
        <!-- https://github.com/vuematerial/vue-material/issues/2285 known bug causing errors with md-select -->
        <md-select 
            v-model="currentIndicator"
            >
            <md-option
                v-for="indicator in indicators"
                :value="indicator"
                :key="indicator"
                >
                    {{indicator}}
                </md-option>
        </md-select>
    </md-field>
</template>
<script>
export default {
    name: "DashboardIndicatorSelect",
    props: {
        indicators: {
            type: Array
        },
        selectedIndicatorName: {
            type: String
        }
    },
    data: () => ({
        currentIndicator: ""
    }),
    watch:{
        /**
         * if the prop gets updated, check that it's a change that came from outside the component
         * i.e. the new indicator isn't the same as the one in this current dropdown and update it
         */
        selectedIndicatorName(newIndicator, oldIndicator){
            if(newIndicator !== oldIndicator && newIndicator !== this.currentIndicator){
                this.currentIndicator = newIndicator;
            }
        },
        /**
         * if user changes indicator dropdown, emit event to update the selectedIndicator in Dashboard
         * to avoid direct prop mutation
         */
        currentIndicator(newIndicator, oldIndicator){
            if(newIndicator !== oldIndicator && newIndicator !== this.selectedIndicatorName){
                this.$emit("user-changed-indicator", newIndicator);
            }
        }
    }
};
</script>